import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

const useAssetAudit = () => {
    const { auditAssetId } = useParams(); // string from URL
    const {
        assetAuditors,
        auditControllers,
        auditLocations,
        auditsList,
        auth
    } = useSelector((state) => state);

    const currentAudit = auditsList?.item;

    const currentAssetAudit = useMemo(
        () =>
            assetAuditors?.data.find(
                (item) => item.auditAsset === parseInt(auditAssetId, 10)
            ),
        [assetAuditors, auditAssetId]
    );

    const currentAssetAuditController = useMemo(
        () =>
            auditControllers?.data.find(
                (item) => item.auditAsset === parseInt(auditAssetId, 10)
            ),
        [auditControllers, auditAssetId]
    );

    const currentLocation = useMemo(
        () =>
            auditLocations?.data.find(
                (item) => item.audit === currentAudit?.id
            ),
        [auditLocations, currentAudit?.id]
    );

    const uploadData = useMemo(
        () => ({
            audit: currentAudit?.id ?? null,
            createdDate: currentAudit?.createdDate ?? null,
            auditAssetContent: [
                {
                    assetController: {
                        assignedDate:
                            currentAssetAudit?.assignedDate ??
                            currentAssetAuditController?.assignedDate ??
                            new Date(),
                        auditAsset:
                            currentAssetAudit?.auditAsset ??
                            currentAssetAuditController?.auditAsset ??
                            parseInt(auditAssetId, 10),
                        controller: auth?.account?.id ?? null,
                        exclusionReason: null
                    },
                    auditImages: [],
                    auditDocuments: [],
                    auditLocation: currentLocation?.location ?? "",
                    notes: []
                }
            ]
        }),
        [
            currentAudit?.id,
            currentAudit?.createdDate,
            currentAssetAudit,
            currentAssetAuditController,
            currentLocation,
            auditAssetId,
            auth?.account?.id
        ]
    );

    return {
        currentAssetAudit,
        currentAssetAuditController,
        currentLocation,
        uploadData
    };
};

export default useAssetAudit;

/**
 * 1. AssignedDate  && AuditAsset ?. &  ??
 * Use the assigned date from the asset audit if it exists,
 * otherwise from the controller if it exists,
 *  otherwise just use the current date
 */
